import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { BuscadorModel } from '../interfaces/buscador-model.interface';

@Component({
  selector: 'app-buscador-facturas',
  templateUrl: './buscador-facturas.component.html',
  styleUrls: ['./buscador-facturas.component.css']
})
export class BuscadorFacturasComponent {

  @Output('valoresEvent') valoresEvent = new EventEmitter<BuscadorModel>();
  @Output('searchEvent') searchEvent = new EventEmitter<boolean>();

  public myform: FormGroup = this.fb.group({
    data: ['', [Validators.required]],
    radioButton: ['numerofactura', Validators.required],
  })  

  constructor(
    private fb: FormBuilder) {
  }

  submitEvent() {   
    this.emitirValores();
    this.searchEvent.emit(true);
  }

  emitirValores(){
    const { data, radioButton } = this.myform.getRawValue();
  
    this.valoresEvent.emit({
      data: data,
      option: radioButton,
    });
  }

}
